// extracted by mini-css-extract-plugin
export var active = "_lr-2";
export var recordingDot = "_lr-1";
export var recordingIndicator = "_lr-0";